import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

export const contactsListRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '/',
    component: lazyRouteComponent(() => import('./ContactList'))
  })
